import { FormControlLabel, Radio, styled, TextField } from '@mui/material';
import { referenceType } from './types';

function Reference(props: {
    reference: referenceType | undefined;
    setReference: (reference: referenceType) => void;
}) {
    const { reference, setReference } = props;
    return (
        <Container>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'salon'} />}
                    onChange={() => setReference({ kind: 'salon', value: '' })}
                    label="Par un salon : lequel ?"
                    name="reference-salon"
                />
                <TextField
                    disabled={reference?.kind !== 'salon'}
                    name="reference-salon-value"
                    fullWidth
                    required={reference?.kind === 'salon'}
                    label="Préciser le salon"
                    onChange={(event) => setReference({ kind: 'salon', value: event.target.value })}
                    value={reference?.kind === 'salon' ? reference.value : ''}
                />
            </RowWithPadding>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'website'} />}
                    onChange={() => setReference({ kind: 'website', value: '' })}
                    label="Par un site internet : lequel ?"
                    name="reference-website"
                />
                <TextField
                    required={reference?.kind === 'website'}
                    disabled={reference?.kind !== 'website'}
                    name="reference-website-value"
                    fullWidth
                    label="Préciser le site internet"
                    onChange={(event) =>
                        setReference({ kind: 'website', value: event.target.value })
                    }
                    value={reference?.kind === 'website' ? reference.value : ''}
                />
            </RowWithPadding>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'socialMedia'} />}
                    onChange={() => setReference({ kind: 'socialMedia', choice: undefined })}
                    label="Par un réseau social :"
                    name="reference-social-media"
                />
                {reference?.kind === 'socialMedia' && (
                    <Row>
                        <FormControlLabel
                            control={<Radio checked={reference.choice?.kind === 'instagram'} />}
                            onChange={() =>
                                setReference({ kind: 'socialMedia', choice: { kind: 'instagram' } })
                            }
                            label="Instagram"
                            name="reference-instagram"
                        />
                        <FormControlLabel
                            control={<Radio checked={reference.choice?.kind === 'linkedin'} />}
                            onChange={() =>
                                setReference({ kind: 'socialMedia', choice: { kind: 'linkedin' } })
                            }
                            label="LinkedIn"
                            name="reference-linkedin"
                        />
                        <FormControlLabel
                            control={<Radio checked={reference.choice?.kind === 'other'} />}
                            onChange={() =>
                                setReference({
                                    kind: 'socialMedia',
                                    choice: { kind: 'other', value: '' },
                                })
                            }
                            label="Autre :"
                            name="reference-other"
                        />
                        <TextField
                            disabled={reference.choice?.kind !== 'other'}
                            required={reference.choice?.kind === 'other'}
                            name="reference-other-value"
                            fullWidth
                            label="Préciser le réseau social"
                            onChange={(event) =>
                                setReference({
                                    kind: 'socialMedia',
                                    choice: { kind: 'other', value: event.target.value },
                                })
                            }
                            value={reference.choice?.kind === 'other' ? reference.choice.value : ''}
                        />
                    </Row>
                )}
            </RowWithPadding>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'formerStudent'} />}
                    onChange={() => setReference({ kind: 'formerStudent', value: '' })}
                    label="Par un(e) ancien(ne) étudiant(e) :"
                    name="reference-former-student"
                />
                <TextField
                    disabled={reference?.kind !== 'formerStudent'}
                    required={reference?.kind === 'formerStudent'}
                    name="reference-formerStudent-value"
                    fullWidth
                    label="Préciser son nom"
                    onChange={(event) =>
                        setReference({ kind: 'formerStudent', value: event.target.value })
                    }
                    value={reference?.kind === 'formerStudent' ? reference.value : ''}
                />
            </RowWithPadding>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'teacher'} />}
                    onChange={() => setReference({ kind: 'teacher', value: '' })}
                    label="Par un(e) enseignant(e) :"
                    name="reference-teacher"
                />
                <TextField
                    label="Préciser son nom"
                    required={reference?.kind === 'teacher'}
                    disabled={reference?.kind !== 'teacher'}
                    name="reference-teacher-value"
                    fullWidth
                    onChange={(event) =>
                        setReference({ kind: 'teacher', value: event.target.value })
                    }
                    value={reference?.kind === 'teacher' ? reference.value : ''}
                />
            </RowWithPadding>
            <RowWithPadding>
                <FormControlLabel
                    control={<Radio checked={reference?.kind === 'other'} />}
                    onChange={() => setReference({ kind: 'other', value: '' })}
                    label="Autre :"
                    name="reference-other"
                />
                <TextField
                    label="Préciser"
                    disabled={reference?.kind !== 'other'}
                    required={reference?.kind === 'other'}
                    name="reference-other-value"
                    fullWidth
                    onChange={(event) => setReference({ kind: 'other', value: event.target.value })}
                    value={reference?.kind === 'other' ? reference.value : ''}
                />
            </RowWithPadding>
        </Container>
    );
}
const Container = styled('div')(({ theme }) => ({}));
const Row = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
}));
const RowWithPadding = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
}));
export { Reference };
